export default __webpack_public_path__ + "static/media/Calculadora.eb59aa52.svg";